import axiosInstance from "../../../helpers/api";

export const listAllMainStudentExams = (search = null) => {
  const params = search ? { search } : {};
  return axiosInstance.get("/admin/student_exams/main_exam", { params });
};

export const redoExam = (studentExamId) => {
  return axiosInstance.post("/admin/student_exams/redo_exam", {
    student_exam_id: studentExamId,
  });
};

export const getStudentExamsByExamId = (examId) => {
  return axiosInstance.get(`/admin/student_exams/get_exams/${examId}`);
};

export const getCorrectionQuestions = (studentExamId) => {
  return axiosInstance.get(`/admin/student_exams/get_questions/${studentExamId}`);
};

export const correctStudentExam = (body) => {
  if (body?.formData instanceof FormData) {
    return axiosInstance.post("/admin/student_exams/correct_exam", body.formData);
  }
  return axiosInstance.post("/admin/student_exams/correct_exam", body);
};

/** Authenticated download — avoids CORS on /public/student_pdfs static files. */
export const getStudentExamFile = (filename) => {
  const safeName = encodeURIComponent(String(filename || "").replace(/^\//, ""));
  return axiosInstance.get(`/admin/student_exams/file/${safeName}`, {
    responseType: "arraybuffer",
  });
};

export const getCorrectedQuestions = (studentExamId) => {
  return axiosInstance.get(`/admin/student_exams/get_corrected_questions/${studentExamId}`);
};

export const getStudentExamReportByChapter = (id) => {
  return axiosInstance.get(`/admin/student_exams/get_student_exam_report_by_chapter/${id}`);
};

